var map = {
	"./community-category/index.sync.tsx": 875,
	"./content-curation/HomepageContentCurationContainer.sync.tsx": 876,
	"./header-navigation/index.sync.tsx": 908,
	"./ideation-destination/filters/ProductAreaFilter.sync.tsx": 925,
	"./knowledge-base/index.sync.tsx": 928,
	"./product-updates-destination/ProductUpdatesOverview.sync.tsx": 945,
	"./site-wide/index.sync.tsx": 965,
	"./topic-banner/TopicBanner.sync.tsx": 1005,
	"./widget-custom-html/index.sync.tsx": 1018,
	"./widget-featured-topics/index.sync.tsx": 394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1390;